import LatencyIcon from "../../fragments/icons/Latency";
import ProfileButton from "../../fragments/ProfileButton";
import useWebSocket from "../../hooks/useWebSocket";

const MobileSidebar = ({ user }) => {
  const { latency } = useWebSocket();
  return (
    <div className="p-4 sm:px-6 flex gap-x-2">
      <ProfileButton user={user} />
      <div className="flex items-center gap-x-2 bg-primary-700 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white">
        <LatencyIcon latency={latency} />
      </div>
    </div>
  );
};
export default MobileSidebar;
